/**
 * This is the project spefic playground for certain features which are to be used in the project.
 *
 * Feel free to add new components and test cases over here
 */

import React, { useState } from "react";
import Query from "@qpr/client-api-base/querybuilder/Query";
import useMeaQuery from "@qpr/client-api-base/apihooks/useMeaQuery";
import { useQuery } from "react-query";
import ScorecardNavigator from "./Scorecards";
import { ICardElement, IScoreCard } from "../../backend/model/model";
import ShowCardNavigator from "./Elements";
import ShowElementData from "./SingleElement";
import { useAppContext } from "@qpr/client-api-base/context/AppCtxProvider";
import { getModel } from "@qpr/client-api-base/api/model";

const getModels = async () => {
  return Query("SC")
    .models()
    .attributes("name")
    .fetchValues<{ id: string; name: string }>();
};

const getScorecards = async () => {
  return Query("SC")
    .models()
    .scorecard()
    .attributes("name")
    .fetchValues<{ id: string; name: string }>();
};

const ShowModels = () => {
  const { isLoading, data } = useQuery("models", () => getModels());
  return <div>{!isLoading ? <div>{JSON.stringify(data)}</div> : null}</div>;
};

const ShowScorecards = () => {
  const { isLoading, data } = useQuery("scorecards", () => getScorecards());
  return (
    <div>{!isLoading ? <pre>{JSON.stringify(data, null, 2)}</pre> : null}</div>
  );
};

/*
  const searchResults = useMeaQuery<SearchResult[]>(
    String.raw`[${modelId}].subobjects(recursive=1, criteria="hasreferencescorecard=\"0\" AND Find(\"${searchKeyword}\", LOWER(measure.value(series=\"JS_ATTR\", period=\"Q1 / 2010\")))")`,
    String.raw`name, symbol, rangevalue, typename, value(period="${ctx.period}",as="performance"), rangecolor(period="${ctx.period}"), value(series="JS_ATTR", period="Q1 / 2010",as="translations"), related(relation=parentObjects, as="parent_id")`,
    undefined,
    {
      ...options,
      enabled: !!modelId && !isThemeLoading && !navi.isLoading
    }
  );
*/
export type SearchResult = {
  id: string;
  name: string;
  typename: string;
  performance: string;
  rangecolor: string;
  translations: string;
  parent_id: string;
  rangevalue?: string;
};
const useSearch = (keyword: string) => {
  const ctx = useAppContext();
  const { data: modelData, isLoading: isModelLoading } = useQuery("model", () =>
    getModel(ctx.model || "")
  );

  const { data, isLoading } = useMeaQuery<SearchResult[]>(
    String.raw`[${
      modelData?.[0]?.id || ""
    }].subobjects(recursive=1, criteria="hasreferencescorecard=\"0\" AND Find(\"${keyword.toLocaleLowerCase()}\", LOWER(measure.value(series=\"JS_ATTR\", period=\"Q1 / 2010\")))")`,
    String.raw`name, symbol, rangevalue, typename, value(period="${ctx.period}",as="performance"), rangecolor(period="${ctx.period}"), value(series="JS_ATTR", period="Q1 / 2010",as="translations"), related(relation=parentObjects, as="parent_id")`,
    undefined,
    {
      enabled: !isModelLoading && !!modelData,
    }
  );
};

const Playground = () => {
  const ctx = useAppContext();
  const { isLoading, data } = useQuery("models", () => getModels());
  const [scorecard, setScorecard] = useState<null | IScoreCard>(null);
  const [element, setElement] = useState<null | ICardElement>(null);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        flexWrap: "nowrap",
        gap: "30px",
      }}
    >
      <div>Model: {ctx.model}</div>
      <div style={{ width: "200px" }}>
        <ScorecardNavigator
          onSelect={(s) => {
            setScorecard(s);
            setElement(null);
          }}
        />
      </div>
      <div>
        {scorecard ? (
          <ShowCardNavigator
            card={scorecard}
            onSelect={(e) => {
              setElement(e);
            }}
          />
        ) : null}
      </div>
      <div>{element ? <ShowElementData card={element} /> : null}</div>
    </div>
  );
};

export default Playground;
